export function requireEnglishIqResponseData<ResponseType>(
  data: ResponseType | undefined,
): ResponseType {
  if (data === undefined) {
    throw new Error('English IQ response data is missing');
  }
  return data;
}
